import React, { useState, useEffect, useRef, useContext } from "react";
import { languages } from "../../content_option"; 
import "./style.css";
import { LanguageContext } from '../../data/language_context';

// Helper function to get language name in the current language
const getLangDisplayName = (lang, currentLanguage) => {
  const langKey = currentLanguage === "Spanish" ? "_esp" : 
                  currentLanguage === "Catalan" ? "_cat" : "_eng";
  const nameKey = `name${langKey}`;
  return lang[nameKey] || lang.name;
};

const LanguageToggle = () => {
  const { language, setLanguage } = useContext(LanguageContext);
  const [open, setOpen] = useState(false);
  
  const toggleRef = useRef();
  
  // Note: localStorage and document lang are now handled in LanguageContext
  // This useEffect is kept only for document lang attribute updates if needed
  // but we should avoid duplicate localStorage writes
  useEffect(() => {
    if (typeof window !== "undefined") {
      document.documentElement.setAttribute("lang", language.slice(0, 2).toLowerCase());
    }
  }, [language]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = e => {
      if (toggleRef.current && !toggleRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentLang = languages.find(lang => lang.name === language);

  return (
    // Parent container for positioning and click-outside logic
    <div className="language_toggle" ref={toggleRef} aria-expanded={open} aria-haspopup="true">
      
      {/* 1. Main Circular Button (Shows current flag) */}
      <button 
        className="language_icon" 
        onClick={() => setOpen(!open)}
        aria-label={`Current language: ${language}. Click to change.`}
      >
        <img 
          src={currentLang?.img} 
          alt={`${language} flag`}
        />
      </button>

      {/* 2. Dropdown Menu (Shows list of flags and names) */}
      {open && (
        <div className="lang_items" role="menu">
          {languages.map((lang, index) => (
            <div
              key={lang.name}
              className={`lang_item ${lang.name === language ? "selected" : ""}`}
              onClick={() => {
                setLanguage(lang.name);
                setOpen(false);
              }}
              title={`Switch to ${lang.name}`}
              role="menuitem"
              aria-checked={lang.name === language}
              tabIndex="0" 
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    setLanguage(lang.name);
                    setOpen(false);
                }
              }}
            >
              <img 
                src={lang?.img} 
                alt={`${lang} flag`}
              />
              <span>{getLangDisplayName(lang, language)}</span> 
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageToggle;